var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.8.7c-5.3 0-12.8 3.1-16.5 6.9L7.9 107C4.1 110.8 1 118.2 1 123.5V168L168.6.7h-44.8z",
    fill: "#FFB494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#993007",
    d: "M.9 168.1l4 5.3V164zM168.6.7l-4 4h9.3z"
  }))));
}
export default SvgBanner;